import { render, staticRenderFns } from "./TraspasosForm.vue?vue&type=template&id=63ce470f&"
import script from "./TraspasosForm.vue?vue&type=script&lang=js&"
export * from "./TraspasosForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports